import React from "react";

import SignUp from "./components/pages/SignUp";
import Home from "./components/pages/Home";
import Login from "./components/pages/Login";
import ForgotPage from "./components/pages/ForgotPage";
import Privacy from "./components/pages/Privacy";
import Terms from "./components/pages/Terms";
import Main from "./components/pages/Main";
import About from "./components/pages/About";
import Affiliate from "./components/pages/Affiliate";
import Pricing from "./components/pages/Pricing";
import Postjob from "./components/pages/Postjob";
import Wallet from "./components/pages/Wallet";
import Campaigns from "./components/pages/Campaigns";
import Mytasks from "./components/pages/Mytasks";

import LoginContext from "./context/LoginContext";

import { ChakraProvider, extendTheme, Text } from "@chakra-ui/react";

import Protected from "./components/widgets/Protected";

import {
  BrowserRouter,
  Router,
  Route,
  Redirect,
  Switch
} from "react-router-dom";

import { auth } from "./firebase";

const theme = extendTheme({
  breakpoints: {
    sm: "480px",
    md: "768px",
    "3md": "851px",
    "2md": "974px",
    lg: "992px",
    "3lg": "1164px",
    "2lg": "1240px",
    xl: "1280px",
    "2xl": "1536px"
  }
});

export default function App() {
  const isLogin = React.useContext(LoginContext);

  React.useEffect(() => {
    auth.onAuthStateChanged((user) => {
      if (user) {
        console.log("user is sign in!");
        isLogin.userInfo({
          displayName: auth.currentUser.displayName,
          email: auth.currentUser.email,
          photoUrl: auth.currentUser.photoURL
        });
        isLogin.login();
      } else {
        console.log("user is not sign in!");
      }
    });
  }, []);

  return (
    <ChakraProvider theme={theme}>
      <BrowserRouter>
        <Switch>
          <div>
            <Route exact path="/" component={Home} />
            <Route exact path="/signup">
              {isLogin.status ? <Redirect to="/main" /> : <SignUp />}
            </Route>
            <Route exact path="/login">
              {isLogin.status ? <Redirect to="/main" /> : <Login />}
            </Route>
            <Route exact path="/forgotpage" component={ForgotPage} />
            <Route exact path="/privacy" component={Privacy} />
            <Route exact path="/terms" component={Terms} />
            <Route exact path="/main">
              <Protected comp={Main} />
            </Route>
            <Route exact path="/about" component={About} />
            <Route exact path="/affiliate-program" component={Affiliate} />
            <Route exact path="/pricing" component={Pricing} />
            <Route exact path="/post-job">
              <Protected comp={Postjob} />
            </Route>
            <Route exact path="/wallet">
              <Protected exact path="/wallet" comp={Wallet} />
            </Route>
            <Route exact path="/campaigns/:id">
              <Protected comp={Campaigns} />
            </Route>
            <Route exact path="/my-tasks">
              <Protected comp={Mytasks} />
            </Route>
          </div>
        </Switch>
      </BrowserRouter>
    </ChakraProvider>
  );
}
